const React = window.React || null;
const { useState, useEffect } = React || null;
import readingTime from 'reading-time';

export default function ArticleReadTime() {

    const [readTimeStr, setReadTimeStr] = useState('');

    useEffect(() => {
        // Check if .non-paywall & .paywall are present in the DOM
        const elNonPaywall = document.querySelector('.aw-article-content>.non-paywall');
        const elPaywall = document.querySelector('.aw-article-content>.paywall');

        let elParagraphsAll: NodeListOf<Element> | null = null;
        if (!elNonPaywall || !elPaywall) {
            elParagraphsAll = document.querySelectorAll('.aw-article-content> p:not(.promo-insert p)');
        } else {
            elParagraphsAll = document.querySelectorAll('.aw-article-content>.non-paywall > p:not(.promo-insert p), .aw-article-content>.paywall > p:not(.promo-insert p)');
        }

        let articleText = '';
        if (elParagraphsAll) {
            elParagraphsAll.forEach((el) => {
                articleText += (el as HTMLElement).innerText;
            });
        }

        // Calculate read time
        const stats = readingTime( articleText );

        if( stats?.text && stats?.words >= 200 ) {
            setReadTimeStr( `${stats.text}` );
        }

    })

    // Animate in read time
    useEffect(() => {
        const elReadTime = document.querySelector('.read-time');
        if( elReadTime && 'function' === typeof anime ) {
            elReadTime.style.visibility = 'visible';
            anime({
                targets: elReadTime,
                opacity: [0,1],
                duration: 300,
                easing: 'easeOutQuad',
                delay: 200,
                loop: false
            })
        }
    }, [readTimeStr]);

    return (
        <>
            {readTimeStr?.length > 0 && 
            <>
                |
                <div>
                    {readTimeStr}
                </div>
            </>
            }
        </>
    )

}